import { render, staticRenderFns } from "./ChangeLang.vue?vue&type=template&id=afb2df44&scoped=true&"
import script from "./ChangeLang.vue?vue&type=script&lang=js&"
export * from "./ChangeLang.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLang.vue?vue&type=style&index=0&id=afb2df44&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb2df44",
  null
  
)

export default component.exports